import { useLifeCycleAnalyticsData } from './useLifeCycleAnalyticsData';
import { useLifeCycleAnalyticsPresentation } from './useLifeCycleAnalyticsPresentation';

export function useLifeCycleAnalyticsOverview(props: any) {
	const data = useLifeCycleAnalyticsData(props);
	return useLifeCycleAnalyticsPresentation(data);
}
